var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTidio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10167_18820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.125 1C15.0625 1 10.75 4.75 9.8125 9.8125C10.375 9.8125 11.125 9.625 11.6875 9.625C11.125 9.625 10.375 9.625 9.8125 9.8125C4.75 10.75 1 15.0625 1 20.3125V31H11.6875C16.75 31 21.0625 27.4375 22.1875 22.375H20.3125C20.125 22.375 19.9375 22.375 19.75 22.375H20.3125H31V11.6875C30.8125 5.6875 26.125 1 20.125 1ZM9.625 11.6875C9.625 12.4375 9.625 13.1875 9.8125 13.75C9.8125 13 9.625 12.4375 9.625 11.6875Z",
    fill: "#135EEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 9.625C11.125 9.625 10.375 9.625 9.8125 9.8125C9.8125 10.375 9.625 11.125 9.625 11.6875C9.625 14.5 10.75 17.3125 12.8125 19.1875C14.875 21.0625 17.5 22.375 20.3125 22.375H22.1875C22.375 21.8125 22.375 21.0625 22.375 20.3125C22.375 17.5 21.25 14.6875 19.1875 12.8125C17.125 10.9375 14.5 9.625 11.6875 9.625Z",
    fill: "#0A60EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 22.375C17.5 22.375 14.6875 21.25 12.8125 19.1875C10.9375 17.125 9.625 14.5 9.625 11.6875C9.625 11.125 9.625 10.375 9.8125 9.8125C4.75 10.75 1 15.0625 1 20.3125V31H11.6875C16.75 31 21.0625 27.4375 22.1875 22.375H20.3125Z",
    fill: "#15C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 1C15.0625 1 10.75 4.75 9.8125 9.8125C10.375 9.8125 11.125 9.625 11.6875 9.625C14.875 9.625 17.875 11.125 19.9375 13.375C22 15.625 22.75 19 22.1875 22.1875H31V11.6875C30.8125 5.6875 26.125 1 20.125 1Z",
    fill: "#2C82FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10167_18820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTidio);
export default __webpack_public_path__ + "static/media/tidio.a9be64579d1b4873ce536e85a841b779.svg";
export { ForwardRef as ReactComponent };